import Axios from './Base'

const PREFIX = '/_api_'

export default class TaxBackCampaign {
  constructor(token) {
    this.token = `Bearer ${token.token}`
    this.wedId = token.token_payload.wed_id
    this.axios = Axios({
      cache: false,
      authorization: this.token,
      wedId: this.wedId,
    })
  }

  async saveCampaignAccept() {
    const axiosWithCache = Axios({
      authorization: this.token,
      wedId: this.wedId,
    })
    const payload = { adesao_campanha: 1 }

    return axiosWithCache
      .post(`${PREFIX}/editJoinedCampaign?wed=${this.wedId}`, payload)
      .then((response) => response.data)
      .catch(() => false)
  }

  async getUserCampaignAdhesion() {
    return this.axios
      .get(`${PREFIX}/GetWedEligibleForCampaign?wed=${this.wedId}`)
      .then((response) => response.data)
      .catch(() => false)
  }
}
